import React, { useState } from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar";
import dayjs, { Dayjs } from "dayjs";
import updateLocale from "dayjs/plugin/updateLocale";
import "./dashboard-chart-section.scss";
import MyTaskChartSection from "./my-task-chart-section";
dayjs.extend(updateLocale);

// Update locale to use short month names
dayjs.updateLocale("en", {
  months: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],
});

interface MyActivitySectionProps {
  setLoading: (loading: boolean) => void;
  setAlertOpen: (open: boolean) => void;
  setAlertMessage: (message: string) => void;
  setAlertType: (type: "error" | "success" | "info" | "warning") => void;
}

const MyActivitySection: React.FC<MyActivitySectionProps> = ({
  setLoading,
  setAlertOpen,
  setAlertMessage,
  setAlertType,
}) => {
  const [date, setDate] = useState<Dayjs | null>(dayjs(new Date()));

  return (
    <>
      <div className="dashboard-chart-section-cards dashboard-chart-section-cards-day">
        <div
          className="dashboard-chart-section-cards-day-section"
          style={{ display: "flex", justifyContent: "center" }}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateCalendar", "DateCalendar"]}>
              <DateCalendar
                value={date}
                onChange={(newValue) => setDate(newValue)}
                sx={{
                  width: 380,
                  "& .MuiPickersDay-root": {
                    width: 45,
                    height: 45,
                    fontSize: "1rem",
                  },
                  "& .MuiPickersCalendarHeader-label": {
                    fontSize: "1.2rem",
                    fontWeight: 600,
                  },
                  "& .MuiDayCalendar-weekDayLabel": {
                    fontSize: "0.9rem",
                    width: 45,
                    height: 45,
                  },
                }}
              />
            </DemoContainer>
          </LocalizationProvider>
        </div>
      </div>
      <MyTaskChartSection
        date={date}
        setLoading={setLoading}
        setAlertOpen={setAlertOpen}
        setAlertMessage={setAlertMessage}
        setAlertType={setAlertType}
      />
    </>
  );
};
export default MyActivitySection;
